import * as Yup from "yup";
import { required } from "../YupSchema";

export const validationConnectOkx = Yup.object().shape({
  apiKey: required,
  secretKey: required,
  passphrase: required,
});
